import React from "react";
import Select from "react-select";

export default function AddMemberRegistration({
  handelClosePopUpClick,
  popupflag,
}) {
  return (
    <>
      <div
        className="modal fade show"
        style={{ display: "block", backgroundColor: "#00000055" }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Member Registration Pop Up
              </h5>
              <button
                onClick={() => handelClosePopUpClick()}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body mx-4">
              <div className="row">
                <div className="col-xl-4 col-lg-4 col-md-4 mt-2">
                  <div className="form">
                    <label>Initial (Miss./Mr./Mrs.)</label>
                    <Select
                    isClearable
                    // isRtl={isRtl}
                    isSearchable
                    // value={{ value: customerNameDDL.ID, label: customerNameDDL.Label }}
                    // onChange={(e) => {
                    //     e ?
                    //         setcustomerNameDDL({ ...customerNameDDL, ID: e.value, Label: e.label })
                    //         :
                    //         setcustomerNameDDL({ ...customerNameDDL, ID: 0, Label: "Select..." })

                    // }}
                    // options={
                    //     customerNameDDL.DDL.map(item => ({
                    //         value: item.value,
                    //         label: item.label,

                    //     }))
                    // }
                  
                  />
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4 col-md-4 mt-2">
                <div className="form">
                  <label>
                    Member Name<span className="text-danger"></span>
                  </label>
                  <input
                    // value={productCategoryName}
                    // onChange={(e) => setproductCategoryName(e.target.value)}
                    type="text"
                    className="form-control"
                    name="DepartmentName"
                    placeholder="Department Name"
                  />
                </div>
                </div>

                <div className="col-xl-4 col-lg-4 col-md-4 mt-2">
                <div className="form">
                  <label>
                    Member Address <span className="text-danger"></span>
                  </label>
                  <input
                    // value={productCategoryName}
                    // onChange={(e) => setproductCategoryName(e.target.value)}
                    type="text"
                    className="form-control"
                    name="DepartmentCode"
                    placeholder="Department Code"
                  />
                </div>
                </div>

                <div className="col-xl-4 col-lg-4 col-md-4 mt-2">
                  <label>State</label>
                  <Select
                    isClearable
                    // isRtl={isRtl}
                    isSearchable
                    // value={{ value: customerNameDDL.ID, label: customerNameDDL.Label }}
                    // onChange={(e) => {
                    //     e ?
                    //         setcustomerNameDDL({ ...customerNameDDL, ID: e.value, Label: e.label })
                    //         :
                    //         setcustomerNameDDL({ ...customerNameDDL, ID: 0, Label: "Select..." })

                    // }}
                    // options={
                    //     customerNameDDL.DDL.map(item => ({
                    //         value: item.value,
                    //         label: item.label,

                    //     }))
                    // }
                  
                  />
                </div>

                <div className="col-xl-4 col-lg-4 col-md-4 mt-2">
                  <label>District</label>
                  <Select
                    isClearable
                    // isRtl={isRtl}
                    isSearchable
                    // value={{ value: customerNameDDL.ID, label: customerNameDDL.Label }}
                    // onChange={(e) => {
                    //     e ?
                    //         setcustomerNameDDL({ ...customerNameDDL, ID: e.value, Label: e.label })
                    //         :
                    //         setcustomerNameDDL({ ...customerNameDDL, ID: 0, Label: "Select..." })

                    // }}
                    // options={
                    //     customerNameDDL.DDL.map(item => ({
                    //         value: item.value,
                    //         label: item.label,

                    //     }))
                    // }
                  
                  />
                </div>

                <div className="col-xl-4 col-lg-4 col-md-4 mt-2">
                  <label>Taluka</label>
                  <Select
                    isClearable
                    // isRtl={isRtl}
                    isSearchable
                    // value={{ value: customerNameDDL.ID, label: customerNameDDL.Label }}
                    // onChange={(e) => {
                    //     e ?
                    //         setcustomerNameDDL({ ...customerNameDDL, ID: e.value, Label: e.label })
                    //         :
                    //         setcustomerNameDDL({ ...customerNameDDL, ID: 0, Label: "Select..." })

                    // }}
                    // options={
                    //     customerNameDDL.DDL.map(item => ({
                    //         value: item.value,
                    //         label: item.label,

                    //     }))
                    // }
                  
                  />
                </div>

                <div className="col-xl-4 col-lg-4 col-md-4 mt-2">
                  <label>Village</label>
                  <Select
                    isClearable
                    // isRtl={isRtl}
                    isSearchable
                    // value={{ value: customerNameDDL.ID, label: customerNameDDL.Label }}
                    // onChange={(e) => {
                    //     e ?
                    //         setcustomerNameDDL({ ...customerNameDDL, ID: e.value, Label: e.label })
                    //         :
                    //         setcustomerNameDDL({ ...customerNameDDL, ID: 0, Label: "Select..." })

                    // }}
                    // options={
                    //     customerNameDDL.DDL.map(item => ({
                    //         value: item.value,
                    //         label: item.label,

                    //     }))
                    // }
                
                  />
                </div>

                <div className="col-xl-4 col-lg-4 col-md-4 mt-2">
                <div className="form">
                  <label>
                    Branch Name<span className="text-danger"></span>
                  </label>
                  <input
                    // value={productCategoryName}
                    // onChange={(e) => setproductCategoryName(e.target.value)}
                    type="text"
                    className="form-control"
                    name="DepartmentCode"
                    placeholder="Department Code"
                  />
                </div>
                </div>

                <div className="col-xl-4 col-lg-4 col-md-4 mt-2">
                  <label>Gender</label>
                  <Select
                    isClearable
                    // isRtl={isRtl}
                    isSearchable
                    // value={{ value: customerNameDDL.ID, label: customerNameDDL.Label }}
                    // onChange={(e) => {
                    //     e ?
                    //         setcustomerNameDDL({ ...customerNameDDL, ID: e.value, Label: e.label })
                    //         :
                    //         setcustomerNameDDL({ ...customerNameDDL, ID: 0, Label: "Select..." })

                    // }}
                    // options={
                    //     customerNameDDL.DDL.map(item => ({
                    //         value: item.value,
                    //         label: item.label,

                    //     }))
                    // }
                  
                  />
                </div>

                <div className="col-xl-4 col-lg-4 col-md-4 mt-2">
                <div className="form">
                  <label>
                    Education<span className="text-danger"></span>
                  </label>
                  <input
                    // value={productCategoryName}
                    // onChange={(e) => setproductCategoryName(e.target.value)}
                    type="text"
                    className="form-control"
                    name="DepartmentCode"
                    placeholder="Department Code"
                  />
                </div>
                </div>

                <div className="col-xl-4 col-lg-4 col-md-4 mt-2">
                <div className="form">
                  <label>
                    Profession<span className="text-danger"></span>
                  </label>
                  <input
                    // value={productCategoryName}
                    // onChange={(e) => setproductCategoryName(e.target.value)}
                    type="text"
                    className="form-control"
                    name="DepartmentCode"
                    placeholder="Department Code"
                  />
                </div>
                </div>

                <div className="col-xl-4 col-lg-4 col-md-4 mt-2">
                <div className="form">
                  <label>
                    Date Of Birth<span className="text-danger"></span>
                  </label>
                  <input
                    // value={productCategoryName}
                    // onChange={(e) => setproductCategoryName(e.target.value)}
                    type="calender"
                    className="form-control"
                    name="DepartmentCode"
                    placeholder="Department Code"
                  />
                </div>
                </div>
                <div className="col-xl-4 col-lg-4 col-md-4 mt-2">
                <div className="form">
                  <label>
                    Mobile Number<span className="text-danger"></span>
                  </label>
                  <input
                    // value={productCategoryName}
                    // onChange={(e) => setproductCategoryName(e.target.value)}
                    type="text"
                    className="form-control"
                    name="DepartmentCode"
                    placeholder="Department Code"
                  />
                </div>
                </div>
                <div className="col-xl-4 col-lg-4 col-md-4 mt-2">
                  <label>Blood Group</label>
                  <Select
                    isClearable
                    // isRtl={isRtl}
                    isSearchable
                    // value={{ value: customerNameDDL.ID, label: customerNameDDL.Label }}
                    // onChange={(e) => {
                    //     e ?
                    //         setcustomerNameDDL({ ...customerNameDDL, ID: e.value, Label: e.label })
                    //         :
                    //         setcustomerNameDDL({ ...customerNameDDL, ID: 0, Label: "Select..." })

                    // }}
                    // options={
                    //     customerNameDDL.DDL.map(item => ({
                    //         value: item.value,
                    //         label: item.label,

                    //     }))
                    // }
                  
                  />
                </div>
                <div className="col-xl-4 col-lg-4 col-md-4 mt-2">
                <div className="form">
                  <label>
                    Upload Image<span className="text-danger"></span>
                  </label>
                  <input
                    // value={productCategoryName}
                    // onChange={(e) => setproductCategoryName(e.target.value)}
                    type="text"
                    className="form-control"
                    name="DepartmentCode"
                    placeholder="Department Code"
                  />
                </div>
                </div>
                <div className="col-12">
                  <div className="form-group float-right mt-4">
                    <button
                      // disabled={productCategoryName === ""}
                      type="button"
                      // onClick={handelSubmit}
                      className="btn btn-add btn-md"
                      data-ktwizard-type="action-next"
                    >
                      {popupflag}
                    </button>
                    <button
                      type="button"
                      // onClick={() => handelClosePopUpClick()}
                      className="btn clear-btn btn-md"
                      data-ktwizard-type="action-next"
                    >
                      CLEAR
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      
    </>
  );
}
